import React, { useState, useEffect } from 'react';
import { FiPlus, FiEdit2, FiX, FiTrash2, FiSearch } from 'react-icons/fi';
import api from '../../utils/api';
import toast from 'react-hot-toast';

const DashboardKategori = () => {
  const [kategoris, setKategoris] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editId, setEditId] = useState(null);
  const [form, setForm] = useState({ nama: '', icon: 'FiFolder', warna: '#f3f4f6' });
  const [search, setSearch] = useState('');

  const load = async () => {
    try { 
      const res = await api.get('/kategori'); 
      setKategoris(res.data.data); 
    } catch (e) { toast.error('Gagal memuat kategori'); } finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editId) { await api.put(`/kategori/${editId}`, form); toast.success('Kategori diperbarui'); }
      else { await api.post('/kategori', form); toast.success('Kategori ditambahkan'); }
      setShowModal(false); setEditId(null); setForm({ nama: '', icon: 'FiFolder', warna: '#f3f4f6' }); load();
    } catch (e) { toast.error(e.response?.data?.message || 'Gagal menyimpan'); }
  };

  const handleEdit = (k) => {
    setEditId(k._id);
    setForm({ nama: k.nama, icon: k.icon || 'FiFolder', warna: k.warna || '#f3f4f6' });
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if(window.confirm('Yakin ingin menghapus kategori ini?')) {
      try {
        await api.delete(`/kategori/${id}`);
        toast.success('Kategori dihapus');
        load();
      } catch (e) {
        toast.error('Gagal menghapus');
      }
    }
  };

  return (
    <div>
      <div className="dashboard-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '1rem' }}>
        <div><h2>Kelola Kategori</h2><p>{kategoris.length} kategori terdaftar</p></div>
        <button className="btn btn-primary" onClick={() => { setEditId(null); setForm({ nama: '', icon: 'FiFolder', warna: '#f3f4f6' }); setShowModal(true); }}><FiPlus /> Tambah</button>
      </div>

      <div style={{ marginBottom: '1.5rem', position: 'relative' }}>
        <FiSearch style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: 'var(--gray-400)' }} />
        <input 
          className="form-input" 
          placeholder="Cari Kategori..." 
          value={search} 
          onChange={(e) => setSearch(e.target.value)} 
          style={{ paddingLeft: '35px', maxWidth: '400px' }} 
        />
      </div>

      {loading ? <div className="loading-spinner"><div className="spinner" /></div> : (
        <div className="table-container">
          <table className="data-table">
            <thead><tr><th>Nama Kategori</th><th>Slug</th><th>Icon</th><th>Warna</th><th>Aksi</th></tr></thead>
            <tbody>
              {kategoris.filter(k => k.nama?.toLowerCase().includes(search.toLowerCase()) || k.slug?.toLowerCase().includes(search.toLowerCase())).map(k => (
                <tr key={k._id}>
                  <td><strong style={{ fontSize: '0.85rem' }}>{k.nama}</strong></td>
                  <td><span className="badge badge-info">{k.slug}</span></td>
                  <td>{k.icon}</td>
                  <td>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                      <div style={{ width: 16, height: 16, borderRadius: '50%', background: k.warna, border: '1px solid #ddd' }}></div>
                      {k.warna}
                    </div>
                  </td>
                  <td>
                    <div style={{ display: 'flex', gap: '0.5rem' }}>
                      <button className="btn btn-ghost btn-sm btn-icon" onClick={() => handleEdit(k)}><FiEdit2 size={14} /></button>
                      <button className="btn btn-ghost btn-sm btn-icon" style={{color: 'var(--danger)'}} onClick={() => handleDelete(k._id)}><FiTrash2 size={14} /></button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3 style={{ fontFamily: 'var(--font-body)', fontSize: '1.1rem' }}>{editId ? 'Edit Kategori' : 'Tambah Kategori'}</h3>
              <button className="btn btn-ghost btn-icon" onClick={() => setShowModal(false)}><FiX /></button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="modal-body">
                <div className="form-group"><label className="form-label">Nama Kategori *</label><input className="form-input" value={form.nama} onChange={(e) => setForm({...form, nama: e.target.value})} required /></div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                  <div className="form-group"><label className="form-label">Icon</label><input className="form-input" value={form.icon} onChange={(e) => setForm({...form, icon: e.target.value})} /></div>
                  <div className="form-group"><label className="form-label">Warna Hex</label><input type="color" className="form-input" style={{height: 42, padding: 5}} value={form.warna} onChange={(e) => setForm({...form, warna: e.target.value})} /></div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-ghost" onClick={() => setShowModal(false)}>Batal</button>
                <button type="submit" className="btn btn-primary">Simpan</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default DashboardKategori;
